import { useCallback } from "react";
import { AppConstants, PlatformApi } from "../../configs";
import { AxiosAuth } from "../../core";
import { ApiResponse } from "../../models/api/common";
import { UpsertVrPhoneAssignmentRequest } from "../../models";

type TinnedUsersResponse = {
  data?: any;
};

type PhoneAssignmentExistsResponse = {
  exists: boolean;
  assignmentId?: string;
  companyId?: string;
  userId?: string;
};

export function useFunctionalityAuthorizeByPhone() {
  const onGetTinnedUsersByCompany = useCallback(async (companyId: string) => {
    const url = PlatformApi.PhoneAssignments.GetTinnedUsersByCompany(companyId ?? "");

    try {
      const res = await AxiosAuth.get<ApiResponse<TinnedUsersResponse>>(url);

      if (res.status === AppConstants.Api.StatusOK) {
        return Promise.resolve(res.data);
      }

      return Promise.resolve(res.data);
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);

  const onGetPagedPhoneAssignments = useCallback(
    async (pageSize?: number, pageNo?: number, searchText?: string) => {
      const url = PlatformApi.PhoneAssignments.GetPagedPhoneAssignments(
        pageSize,
        pageNo,
        searchText
      );

      try {
        const res = await AxiosAuth.post<ApiResponse<any>>(url, {});

        if (res.status === AppConstants.Api.StatusOK) {
          return Promise.resolve(res.data);
        }

        return Promise.resolve(res.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  const onUpsertPhoneAssignment = useCallback(
    async (payload: UpsertVrPhoneAssignmentRequest) => {
      const url = PlatformApi.PhoneAssignments.CreatePhoneAssignment();

      try {
        const res = await AxiosAuth.post<ApiResponse<any>>(url, payload);

        if (res.status === AppConstants.Api.StatusOK) {
          return Promise.resolve(res.data);
        }

        return Promise.resolve(res.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  const onPatchEnabledPhoneAssignment = useCallback(
    async (id: string, isEnabled: boolean) => {
      const url = PlatformApi.PhoneAssignments.PatchEnabledPhoneAssignement(
        id ?? "",
        isEnabled
      );
      const payload = { isEnabled };

      try {
        const res = await AxiosAuth.patch<ApiResponse<any>>(url, payload);

        if (res.status === AppConstants.Api.StatusOK) {
          return Promise.resolve(res.data);
        }

        return Promise.resolve(res.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  const onDeletePhoneAssignment = useCallback(async (id: string) => {
    const url = PlatformApi.PhoneAssignments.DeletePhoneAssignment(id ?? "");

    try {
      const res = await AxiosAuth.delete<ApiResponse<any>>(url);

      if (res.status === AppConstants.Api.StatusOK) {
        return Promise.resolve(res.data);
      }

      return Promise.resolve(res.data);
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);

  const onCheckPhoneAssignmentExists = useCallback(
    async (phoneNumber: string, excludeId?: string) => {
      const url = PlatformApi.PhoneAssignments.IsPhoneAssignmentExist(
        phoneNumber,
        excludeId
      );

      try {
        const res = await AxiosAuth.get<ApiResponse<PhoneAssignmentExistsResponse>>(url);

        if (res.status === AppConstants.Api.StatusOK) {
          return Promise.resolve(res.data);
        }

        return Promise.resolve(res.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    []
  );

  return {
    onGetTinnedUsersByCompany,
    onGetPagedPhoneAssignments,
    onUpsertPhoneAssignment,
    onPatchEnabledPhoneAssignment,
    onDeletePhoneAssignment,
    onCheckPhoneAssignmentExists,
  };
}
